import PropTypes from "prop-types";
import { Button, Container, Stack, Typography } from "@mui/material";
import { useLocales } from "@locales";
import { isEmbedMode } from "../../utils/iframe";

/**
 * Shown instead of a seller page that belongs to another marketplace than the white-label domain
 * it was opened on (#1407) — e.g. Villa Accadia's member page under members.kaeteclub.com.
 */
export const ForeignMarketplaceNotice = ({ sellerName, url }) => {
    const { translate } = useLocales();
    const name = sellerName || translate('seller_public.foreign_marketplace.this_club');

    return (
        <Container maxWidth="sm" data-testid="foreign-marketplace-notice">
            <Stack alignItems="center" textAlign="center" gap={2} sx={{ py: 10 }}>
                <Typography variant="h5">
                    {translate('seller_public.foreign_marketplace.title', { name })}
                </Typography>
                <Typography variant="body1" color="text.secondary">
                    {translate('seller_public.foreign_marketplace.body', { name })}
                </Typography>
                {/* in an embed iframe / app webview, leave the frame rather than load another origin inside it */}
                <Button variant="contained" size="large" href={url} target={isEmbedMode() ? '_top' : undefined}>
                    {translate('seller_public.foreign_marketplace.cta', { name })}
                </Button>
            </Stack>
        </Container>
    );
};

ForeignMarketplaceNotice.propTypes = {
    sellerName: PropTypes.string,
    url: PropTypes.string.isRequired,
};
